import './SelectListMulti.css'
import React from 'react'
import { Checkbox } from '../Checkbox/Checkbox'
import cx from 'classnames'
import { radioCheckboxClasses } from '../RadioGroup/RadioGroup'
import { Label } from '../InputLabel/InputLabel'

function CheckboxSelectListItem({
  id,
  label,
  onChange,
  children,
  isOpen,
  isChecked,
  tooltip,
  tooltipPlacement,
  tooltipSize
}: {
  id: string
  label: string
  onChange: (checked: boolean) => void
  children?: React.ReactNode
  isOpen?: boolean
  isChecked: boolean
  tooltip?: string
  tooltipPlacement?: 'top' | 'bottom'
  tooltipSize?: 'small' | 'medium' | 'large'
}) {
  return (
    <div className="select-list-multi-item">
      <label
        htmlFor={id}
        className={cx(
          'select-list-multi-item-label',
          !isOpen && 'select-list-multi-item-label-closed'
        )}
      >
        <Checkbox onChange={checked => onChange(checked)} checked={isChecked} id={id} />
        <Label
          tooltip={tooltip}
          tooltipPlacement={tooltipPlacement}
          tooltipSize={tooltipSize}
          className={cx(radioCheckboxClasses.label)}
        >
          {label}
        </Label>
      </label>
      {isOpen && <div className="select-list-multi-item-children">{children}</div>}
    </div>
  )
}

export function SelectListMulti({
  className,
  onChange,
  items
}: {
  className?: string
  onChange: (id: string, checked: boolean) => void
  items: {
    id: string
    label: string
    children?: React.ReactNode
    isOpen?: boolean
    isChecked: boolean
    tooltip?: string
    tooltipPlacement?: 'top' | 'bottom'
    tooltipSize?: 'small' | 'medium' | 'large'
  }[]
}) {
  return (
    <ol className={cx('select-list-multi-container', className)}>
      {items.map(item => (
        <li key={item.id}>
          <CheckboxSelectListItem
            id={item.id}
            label={item.label}
            onChange={checked => onChange(item.id, checked)}
            isOpen={item.isOpen}
            isChecked={item.isChecked}
            tooltip={item.tooltip}
            tooltipPlacement={item.tooltipPlacement}
            tooltipSize={item.tooltipSize}
          >
            {item.children}
          </CheckboxSelectListItem>
        </li>
      ))}
    </ol>
  )
}
